import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";
import { FundRecommendationResponse } from "@rentablo/api/recommender";
import { InfoChip } from "@components/InfoChips/types";

export const useRecommendationTags = (
  recommendation: FundRecommendationResponse
) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { fund, explanation } = recommendation;
  const outperforming_metrics = explanation?.outperforming_metrics;
  const tags: InfoChip[] = [];

  // Tag "X% Weniger Gebühren"
  if (outperforming_metrics?.ter && outperforming_metrics.ter > 0) {
    const terPercentage = outperforming_metrics.ter;
    tags.push({
      text: t("recommender.tags.lowerFees", { percentage: terPercentage }),
      color: theme.palette.graphVisual["06"].subtle,
      textColor: theme.palette.graphVisual["06"].dark,
      tooltip: t("recommender.tags.lowerFeesTooltip"),
    });
  }

  // Tag "X% Höhere Rendite"
  if (
    outperforming_metrics?.performance &&
    outperforming_metrics.performance > 0
  ) {
    const performancePercentage = outperforming_metrics.performance;
    tags.push({
      text: t("recommender.tags.higherReturn", {
        percentage: performancePercentage,
      }),
      color: theme.palette.graphVisual["02"].subtle,
      textColor: theme.palette.graphVisual["02"].dark,
    });
  }

  // Tag "X% niedrigeres Risiko"
  if (
    outperforming_metrics?.volatility &&
    outperforming_metrics.volatility > 0
  ) {
    const volatilityPercentage = outperforming_metrics.volatility;
    tags.push({
      text: t("recommender.tags.lowerRisk", {
        percentage: volatilityPercentage,
      }),
      color: theme.palette.graphVisual["09"].subtle,
      textColor: theme.palette.graphVisual["09"].dark,
    });
  }

  // Tag "Ausschüttend" / "Thesaurierend"
  if (fund?.dividend_distribution_policy === "DISTRIBUTING") {
    tags.push({
      text: t("recommender.tags.distributing"),
      color: theme.palette.graphVisual["11"].subtle,
      textColor: theme.palette.graphVisual["11"].dark,
    });
  } else if (fund?.dividend_distribution_policy === "RETAINED") {
    tags.push({
      text: t("recommender.tags.retaining"),
      color: theme.palette.graphVisual["11"].subtle,
      textColor: theme.palette.graphVisual["11"].dark,
    });
  }

  // Tag "Beliebt bei anderen Anlegern"
  if (fund?.volume && fund.volume >= 1000) {
    tags.push({
      text: t("recommender.tags.popular"),
      color: theme.palette.graphVisual["12"].subtle,
      textColor: theme.palette.graphVisual["12"].dark,
      tooltip: t("recommender.tags.popularTooltip"),
    });
  }

  // Tag "Sparplanfähig"
  if (fund?.has_savings_plan) {
    tags.push({
      text: t("recommender.tags.savingsPlan"),
      color: theme.palette.graphVisual["13"].subtle,
      textColor: theme.palette.graphVisual["13"].dark,
    });
  }

  return {
    tags,
  };
};
